module.exports = __webpack_public_path__ + "img/wfirer.356b24c6.png";